import React from 'react';
import {
  Card,
  Stack,
  Link,
  Avatar,
  Heading,
  TextContainer,
} from '@shopify/polaris';
import { getInitials } from 'utils/strings';

export default function PayoutReceiver({ receiver_name, receiver_id }) {
  return receiver_name ? (
    <Card.Section
      title={
        <Stack distribution="equalSpacing">
          <Stack.Item>
            <Heading>Receiver</Heading>
          </Stack.Item>
          <Stack.Item>
            <Link url={`/customers/${receiver_id}`}>
              <Avatar
                initials={getInitials(receiver_name)}
                name={receiver_name}
                size="small"
              ></Avatar>
            </Link>
          </Stack.Item>
        </Stack>
      }
      sectioned
    >
      <TextContainer>
        <Link url={`/customers/${receiver_id}`}>{receiver_name}</Link>
      </TextContainer>
    </Card.Section>
  ) : null;
}
